import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import { getApp } from 'owa-config';
import { getLogicalRing } from 'owa-config';

export default function createAlchemyClientContext(
    userConfig: OwaUserConfiguration,
    invokedBy: string
) {
    let sessionStartTime = new Date();
    sessionStartTime.setTime(window.performance.timing.fetchStart);

    const clientContext = {
        Country: userConfig.UserOptions.TimeZone,
        Platform: window.navigator.platform,
        BrowserLanguage: window.navigator.language,
        MbxCulture: userConfig.SessionSettings.UserCulture,
        OwaLayout: getApp(),
        OwaUtcStartTime: String(sessionStartTime),
        Ring: getLogicalRing(),
        Forest: window.bootstrapDiagnostics.fost,
        InvokedBy: invokedBy,
    };

    return JSON.stringify(clientContext);
}
